import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './main/not-found/not-found.component';
import { UserComponent } from './main/user/user.component';
import { ContentComponent } from './main/content/content.component';
import { RegistrationComponent } from './main/registration/registration.component';
import { LoginComponent } from './main/login/login.component';
import { authGuard } from './core/guards/auth.guard';
import { activateCompanyGuard } from './core/guards/company.guard';
import { authRedirectionGuard } from './core/guards/auth-redirection.guard';
import { ForgotPasswordComponent } from './main/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './main/reset-password/reset-password.component';
import { leavePageGuard } from './core/guards/leave-page.guard';
import { ChangePasswordComponent } from './main/change-password/change-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'registration',
    component: RegistrationComponent,
    canActivate: [authRedirectionGuard]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [authRedirectionGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [authGuard]
  },
  {
    path: 'user',
    component: UserComponent,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./main/user/user.module').then((u) => u.UserModule)
  },
  {
    path: 'companies/:id',
    component: ContentComponent,
    canActivate: [authGuard, activateCompanyGuard],
    canDeactivate: [leavePageGuard],
    loadChildren: () =>
      import('./main/content/content.module').then((c) => c.ContentModule)
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
